import TrashLight from '@/images/TrashLight.svg';
import { ControlIconButton } from '@/pages/AdvancedEditor/components/panels/common/ControlIconButton';
import styled from '@emotion/styled';

const StyledControlIconButton = styled(ControlIconButton)`
    position: absolute;
    z-index: 15;
    top: 4px;
    right: 4px;

    visibility: hidden;
`;

interface Props {
    onClick: () => Promise<void>;
    className?: string;
}

export const DeleteButton = ({ onClick, className }: Props) => {
    const handleClick = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        await onClick();
    };

    return (
        <StyledControlIconButton
            src={TrashLight}
            ariaLabel=""
            className={className}
            onClick={handleClick}
            imageStyle={{ width: '16px', height: '16px' }}
        />
    );
};
